module.exports = __webpack_public_path__ + "assets/line-5.14e2f53a.svg";